import { Expr } from "./Expr";
import { EqualsXpr } from "./constraints/compare/EqualsXpr";
import { NotEqualsXpr } from "./constraints/compare/NotEqualsXpr";
import { AndXpr } from "./constraints/logical/AndXpr";
import { OrXpr } from "./constraints/logical/OrXpr";
import { GreaterThanEqualsXpr } from "./constraints/compare/GreaterThanEqualsXpr";
import { GreaterThanXpr } from "./constraints/compare/GreaterThanXpr";
import { LessThanXpr } from "./constraints/compare/LessThanXpr";
import { LessThanOrEqualXpr } from "./constraints/compare/LessThanOrEqualXpr";

// Binary operators that use left/right operands
export type BinaryExpressionType =
  | "=="
  | "!="
  | "&&"
  | "||"
  | ">"
  | ">="
  | "<"
  | "<=";
export interface BinaryExprStructure {
  $type: BinaryExpressionType;
  left: Expr;
  right: Expr;
}

export type BinaryExpr =
  | EqualsXpr
  | NotEqualsXpr
  | AndXpr
  | OrXpr
  | GreaterThanXpr
  | GreaterThanEqualsXpr
  | LessThanXpr
  | LessThanOrEqualXpr;

export const binaryExpr = (
  $type: BinaryExpressionType,
  left: Expr,
  right: Expr
): BinaryExpr => {
  return {
    $type,
    left,
    right,
  };
};
